import React, { useEffect } from 'react';
import { useData, useDispatch } from 'resift';
import makeGetUserFieldsFetch from 'fetches/makeGetUserFieldsFetch';
import CircularProgress from '@material-ui/core/CircularProgress';
import RolesAndPermissionsPage from './RolesAndPermissionsPage';

function Container() {
  const dispatch = useDispatch();
  const getUserFields = makeGetUserFieldsFetch();
  const userFields = useData(getUserFields);

  useEffect(() => {
    if (!userFields) {
      dispatch(getUserFields());
    }
  }, []);

  if (!userFields) {
    return <CircularProgress color="secondary" />;
  }

  return <RolesAndPermissionsPage />;
}

export default Container;
